module.exports = __webpack_public_path__ + "img/link.3abfba01.svg";